import Marquee from "react-fast-marquee";

export const MarqueeBar = ({ items, direction = "left" }) => {
  return (
    <div className="py-10 border-y border-white/10 bg-[#050505] overflow-hidden" data-testid="marquee-bar">
      <Marquee speed={40} direction={direction} gradient={false}>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-anton uppercase text-6xl md:text-8xl mx-8 stroke-text">
              {item}
            </span>
            <span className="w-4 h-4 rounded-full bg-[#5cc6ff] mx-8" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
